export function daysForLocale(locale = 'en-GB', weekday = 'short') {
    const format = new Intl.DateTimeFormat(locale, { weekday }).format;
    return [...Array(7).keys()].map(day => format(new Date(Date.UTC(2021, 5, day))));
}
